<script>
import {myPath} from "@/utils/constant";
import {getEnvInfo} from "@/utils/native-bridge";
import {unbindDevice} from "@/api/device-api";

export default {
  name: "SettingPage",
  data() {
    return {
      envInfo: getEnvInfo(),
      settingList: [
        {key: "rebind", show: "重新绑定设备"},
        // 身份证识别/USB 打印/人脸 SDK 依赖安卓壳（visitor-app），纯 H5 部署暂不支持
      ],
      switchList: [
        {key: "Setting.SignEnterPhoto", show: "签到照片是否必填"},
        {key: "Setting.printEnterInfo", show: "是否打印签到凭证"},
      ],
      switchValues: {
        "Setting.SignEnterPhoto": false,
        "Setting.printEnterInfo": false,
      }
    }
  },
  mounted() {
    // 开关经 plugins.js 的 JavaBaseInfo 桩持久化到 localStorage
    this.switchValues["Setting.SignEnterPhoto"] = this.JavaBaseInfo.getBaseInfo("Setting.SignEnterPhoto") === "1" // 默认关，需显式开启
    this.switchValues["Setting.printEnterInfo"] = this.JavaBaseInfo.getBaseInfo("Setting.printEnterInfo") === "1" // 默认关，需显式开启
  },
  methods: {
    onRebind() {
      this.$confirm('将清除本机的设备绑定信息并释放设备授权码（后台可重新分配），是否继续？', '重新绑定设备', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 先通知后台释放授权码（BOUND→ASSIGNED）并停用设备记录；须在清本地 token 前调用。
        // 释放失败不阻塞本地解绑（离线/接口异常时设备仍可本地重绑）。
        try {
          await unbindDevice()
        } catch (err) {
          console.log("unbindDevice err（忽略，继续本地解绑）", err)
        }
        this.$store.commit("clearTerminalSession")
        this.JavaBaseInfo.setBaseInfo("token", "")
        this.JavaBaseInfo.setBaseInfo("connect", "false")
        this.$router.push({name: this.myPath.loading})
      }).catch(() => {
      })
    },

    onBackClick() {
      this.$router.back()
    },

    onSwitchChange(item) {
      console.log("onSwitchChange", item.key, this.switchValues[item.key])
      this.JavaBaseInfo.setBaseInfo(item.key, this.switchValues[item.key] ? "1" : "0")
    },
  }
}
</script>

<template>
  <!-- theme-a：居中标题 + 右上圆返回 + 卡片设置项（对齐 LocalAddInfo 等流程页） -->
  <div class="common-page-box">
    <div class="back-btn" @click="onBackClick">
      <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
    </div>

    <div class="page-title" style="font-size:64px;margin-top:48px">设置</div>

    <div class="card" style="margin:40px 96px 16px;flex:1;overflow:auto;padding:56px 88px">
      <!-- 设备环境信息（供现场排查用） -->
      <div class="env-box">
        <div class="env-line"><span>当前环境</span><b>{{ envInfo.os }}</b></div>
        <div class="env-line"><span>设备机型</span><b>{{ envInfo.model }}</b></div>
        <div class="env-line"><span>屏幕分辨率</span><b>{{ envInfo.screen.width }} x {{ envInfo.screen.height }} ({{ envInfo.screen.dpr }}x)</b></div>
        <div class="env-line"><span>设备指纹</span><b>{{ envInfo.fingerprint }}</b></div>
      </div>

      <div v-for="item in settingList" class="setting-item" @click="onRebind" :key="item.key">
        <div class="setting-label">{{ item.show }}</div>
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#86909c" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>
      </div>
      <div v-for="item in switchList" class="setting-item" :key="item.key">
        <div class="setting-label">{{ item.show }}</div>
        <el-switch v-model="switchValues[item.key]" @change="onSwitchChange(item)"></el-switch>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.env-box {
  padding: 8px 40px 32px;
  border-bottom: 1px solid var(--line);

  .env-line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    line-height: 1.8;

    span {
      color: var(--ink-3);
      font-size: 28px;
    }

    b {
      font-size: 30px;
      font-weight: 500;
      color: var(--ink);
    }
  }
}

.setting-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 36px 40px;
  border-bottom: 1px solid var(--line);
  cursor: pointer;
  transition: background 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: rgba(47, 107, 255, 0.04);
  }

  .setting-label {
    font-size: 32px;
    color: var(--ink);
  }
}
</style>
